import { render } from "./DesignSplit.vue?vue&type=template&id=6254fb88&scoped=true"
import script from "./DesignSplit.vue?vue&type=script&lang=js"
export * from "./DesignSplit.vue?vue&type=script&lang=js"

import "./DesignSplit.vue?vue&type=style&index=0&id=6254fb88&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6254fb88"]])

export default __exports__